import { Box } from '@mui/material';

export const CreateTabAria = (isTabPanel: boolean, uniqueId: string, index: number) => {
  const tabId = `${uniqueId}_${index}`;
  return {
    id: isTabPanel ? `${tabId}_tabpanel` : `${tabId}_tab`,
    'aria-controls': isTabPanel ? undefined : `${tabId}_tabpanel`,
    'aria-labelledby': isTabPanel ? `${tabId}_tab` : undefined,
  };
};

type TabPanelProps = {
  children: React.ReactNode;
  index: number;
  value: number;
  padding: boolean;
};

const Padded = ({ condition, children }) => (condition ? <Box sx={{ p: 3 }}>{children}</Box> : children);

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, padding, ...other } = props;

  return (
    <div role='tabpanel' hidden={value !== index} {...other}>
      <Padded condition={padding}>{children}</Padded>
    </div>
  );
};
